/**
 * Provider that supplies shared defaults (apiClient, tenant, module)
 * to all integrated components in its subtree.
 */

import * as React from 'react';
import { IntegratedComponentContext } from './IntegratedComponentContext';
import type { IntegratedComponentContextValue } from './types';

interface IntegratedComponentProviderProps extends IntegratedComponentContextValue {
  children: React.ReactNode;
}

export function IntegratedComponentProvider({
  apiClient,
  tenant,
  module,
  children,
}: Readonly<IntegratedComponentProviderProps>): React.ReactElement {
  const value = React.useMemo<IntegratedComponentContextValue>(
    () => ({ apiClient, tenant, module }),
    [apiClient, tenant, module],
  );

  return (
    <IntegratedComponentContext.Provider value={value}>
      {children}
    </IntegratedComponentContext.Provider>
  );
}

IntegratedComponentProvider.displayName = 'IntegratedComponentProvider';
